import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import { constructionAsset, constructionSafety, logisticsAsset } from '@pages/Enterprise/Solution/components/Banner/BannerImages';

export default {
  desc: 'ORBRO cung cấp các dịch vụ nâng cao trải nghiệm của hành khách và tăng cường hiệu quả vận hành thông qua việc theo dõi vị trí của phương tiện giao thông công cộng theo thời gian thực. Để thực hiện điều này, ORBRO cung cấp thông tin vị trí theo thời gian thực của xe buýt và tàu điện ngầm, hiển thị thông tin trạm dừng/nhà ga, phân tích và tối ưu hóa luồng giao thông, quản lý và giám sát an toàn, cũng như tích hợp ứng dụng và dịch vụ.',
  keywords: 'Bản sao số, tình hình giao thông, thành phố số, thực tế ảo, ban sao so, tinh hinh giao thong, thanh pho so, thuc te ao.',
  ogSite: 'Digital Twin - Kết nối thông tin Xe buýt và Tàu điện ngầm',
  title: 'Digital Twin - Kết nối thông tin Xe buýt và Tàu điện ngầm',
  ogUrl: 'https://orbro.io/vi/blog/digitaltwin-traffic',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AGXqzDmsHKPo0k1JGpYe5RqcLPvhvPsttOE54okj7zmGDmBsNO7w1O-JK1oTjUeN0SXoXeuVHVRR0yqY597xyclhreNiwqO8zxMhslWsAccGNFJL7Cc4jphNGY1U-ApF8rYUJlkQ29hCvXhs1-kJ7ItJ8yzqul6tD2bkCeeSf24qL0tmKPNG7wJdcdkE8HnxTJ-dAJvm-HQ1tD8-RFPjUfTcllJI-RCb7dzd6jATNYzQbe1GQD7gejTG574T2T6jKa1sIQLT1me2evIreAszenpfb2ZOAOafbrlQEnfJCF577BDuUZxdtYW-PpTWZdcoK_GlrZTVEXWFVIe4zYY4BA9uI-4MvLCytQ19heux-zPZ2uj0Pd-eu04szV3P6TFIG2dqGtdzui7sXRbRh4-9toRM1UEYley9vu4sOHPbxuwV1LN97GHKbtKrmz4OsgOS0jK8VWR0v_KCwr08MXIduU_b2QT5axXUH4CSftoADRRfaDprmZIqjdAdy7RqILvmsg_V7NQAcd9xapuxx4MMoC42nj2n0iwd9yZV--15jzcgqW6daHUiYEZ4ggt7Uy2LoPScqjh7hhOm8vT1XPj6fSf3W1SgBduBXU9h5e0_bG9GKZLWMCy72SHi0Xs0NO0X7FSOgdDU0scaP-F8WlOsTezavpMEhxUlz2fhL_mBIfZVO25KKS-y-Qfuul0bpf2coLNtuVO4yW_hZEZuAzW7FbuIUdoyI04V7I493a1IXz6-A_ZcTH2j2retDHu_nD6RnBrnlcCsY0tnVCMM0ho0k_GLGaGTrs_88IPxii47Y_Qa1XXH-8-wwpGN0UocvGhXB6rdM7S-m7_MIT3ONC4MyvE3Bqjkid-QLeYtThJ2zXLCXfCIaCyi4jttco-MJjx84qBVRrUWpwcvpISJ7E9pYCJukWT1rgVNPsgO1baez2jR2IyH1hMZ4SXB6nHNVoylyuvAjn1uYfjDCfOgRlqmcK8wt3U1GImqc68KthjcbhAjDNmlLNtBl9Pd4Ksg0Xts8R_Z_LbV6Ue834BoCmu5H_jzmEevCkvwPsYoLsmqebwEqmrp2B58f2e32e0YY8L8jPuMPX3UDZyxX98adUK-gekxc1YB5JrqJPlcC4nZA-XLh8EmakSbt83hYYjIkhbHeafd7Hr5M-Em9znV_sFo2DaAwfkAQRoa80pNidI39UxDJVdey6nVP9H6UPL-i_N-H1K6LpiALIwQNKPMlI4up5e-hme40ZgUL9QKbBaKDyfOxk1aqml1cTzHCZJRP_jLw2dOoS1K-EG7OsGJDxmnclokA0StmKuFCPLAbAodPa1K_Btbk2GtITh4kvm07TLOp_LDZBnztDlzA8WuId3bEWiXNRc5qKlfv5UYlEn_k4L03K4A-T49R-Pi75Jp53wW68HhGwDoSbyYjaiI8plzJeyMyGJduXJZtYWh66ETIXdt8IxUDYw5otbzXD-lFsSLdM09U37NH_lU0c07Sjg77a4m1OfI1-mfJmHzqzvn9kksa3H2aYES0HhIq5RPgdd0NyW7b2IvL9b7nDE4tL4D-hf70biexJ_aaBkb=w1923-h1074',
  ogType: 'website',
  date: '2023-12-26',
  tag1: '#Bansaoso',
  tag2: '#Tinhhinhgiaothong',
  tag3: '#Thanhphoso',
  tag4: '#Thucteao',
  text: [
    {
      head: 'Digital Twin - Kết nối thông tin xe buýt và tàu điện ngầm',
      subHead: '',
      desc: 'ORBRO cung cấp các dịch vụ nâng cao trải nghiệm của hành khách và tăng cường hiệu quả vận hành thông qua việc theo dõi vị trí của phương tiện giao thông công cộng theo thời gian thực. Để thực hiện điều này, ORBRO cung cấp thông tin vị trí theo thời gian thực của xe buýt và tàu điện ngầm, hiển thị thông tin trạm dừng/nhà ga, phân tích và tối ưu hóa luồng giao thông, quản lý và giám sát an toàn, cũng như tích hợp ứng dụng và dịch vụ.\nCông nghệ GPS và theo dõi của ORBRO cung cấp chính xác vị trí theo thời gian thực của xe buýt, cho phép hành khách nắm bắt thông tin vận hành của phương tiện giao thông công cộng một cách tức thời. Việc giám sát vị trí theo thời gian thực của tàu điện ngầm cung cấp cho hành khách thông tin vận hành chính xác, nâng cao độ tin cậy khi sử dụng phương tiện giao thông công cộng.\nViệc cung cấp thông tin trạm dừng/nhà ga giúp tăng sự tiện lợi khi sử dụng phương tiện giao thông công cộng, trong khi việc phân tích và tối ưu hóa luồng giao thông góp phần giảm ùn tắc và rút ngắn thời gian chờ đợi của hành khách. Ngoài ra, công tác quản lý và giám sát an toàn đặt trọng tâm vào sự an toàn của hành khách và hỗ trợ vận hành thông suốt hệ thống giao thông công cộng.\nKết quả là, ORBRO mang đến trải nghiệm tốt hơn cho người sử dụng phương tiện giao thông công cộng, đồng thời nâng cao hiệu quả của hệ thống giao thông công cộng, qua đó cải thiện môi trường giao thông đô thị.',
      dot: '',
    },
    {
      head: 'Theo dõi vị trí xe buýt theo thời gian thực',
      subHead: '',
      desc: 'ORBRO sử dụng công nghệ GPS và theo dõi để cung cấp vị trí của xe buýt theo thời gian thực. Điều này cho phép hành khách dự đoán chính xác thời gian xe đến, đồng thời giúp các nhà quản lý giao thông nâng cao hiệu quả vận hành.',
      dot: '',
    },
    {
      head: 'Giám sát vị trí tàu điện ngầm theo thời gian thực',
      subHead: '',
      desc: 'ORBRO giám sát và hiển thị vị trí của các đoàn tàu trong hệ thống tàu điện ngầm theo thời gian thực, cung cấp cho hành khách thông tin vận hành chính xác. Điều này nâng cao hiệu quả vận hành và cho phép phản ứng nhanh chóng trong các tình huống khẩn cấp.',
      dot: '',
    },
    {
      head: 'Cung cấp thông tin trạm dừng/nhà ga',
      subHead: '',
      desc: 'ORBRO hiển thị thông tin chi tiết về từng trạm dừng và nhà ga trên bản đồ kỹ thuật số, qua đó cung cấp cho hành khách thông tin về vị trí trạm, lịch trình, và các dịch vụ, giúp tăng cường sự tiện lợi khi sử dụng phương tiện giao thông công cộng.',
      dot: '',
    },
    {
      head: 'Phân tích và tối ưu hóa luồng giao thông',
      subHead: '',
      desc: 'ORBRO sử dụng dữ liệu vị trí theo thời gian thực để phân tích và tối ưu hóa luồng giao thông. Điều này góp phần giảm ùn tắc giao thông và rút ngắn thời gian chờ đợi của hành khách.',
      dot: '',
    },
    {
      head: 'Quản lý và giám sát an toàn',
      subHead: '',
      desc: 'ORBRO tăng cường các hệ thống quản lý và giám sát an toàn bên trong phương tiện giao thông công cộng, đảm bảo an toàn cho hành khách và ứng phó nhanh chóng với các tình huống nguy hiểm trong quá trình vận hành.',
      dot: '',
    },
    {
      head: 'Tích hợp ứng dụng và dịch vụ',
      subHead: '',
      desc: 'ORBRO tích hợp thông tin giao thông công cộng với các ứng dụng di động và nhiều dịch vụ kỹ thuật số khác nhau, mang đến cho hành khách khả năng tiếp cận thông tin tốt hơn và sự tiện lợi cao hơn.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: constructionAsset.thumb,
        data: 'constructionAsset',
        link: '/vi/enterprise/construction/asset',
      },
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/vi/enterprise/construction/safety',
      },
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/vi/enterprise/logistics/asset',
      },
    ],
  },
};
